export const color1 = '#ffffff';
export const color2 = '#f2a626';
export const color3 = '#2b2e2d';
export const color4 = '#181817';
